export default __webpack_public_path__ + "static/media/react.5093c500.svg";